/**
 * The two-stage neon glow filter used by lit elements: a tight blur at full
 * strength plus a wide blur at about 0.55 strength, merged over the source
 * shape. Copied from the dossier card's `#dossier-neon` filter (recipe 2.3,
 * `app/src/glasses/card/DossierCard.tsx`) so the map's lit strokes render
 * with the same look without importing the card component itself.
 */
export default function MapNeonDefs() {
  return (
    <defs>
      <filter id="mu-neon" x="-40%" y="-40%" width="180%" height="180%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="tight" />
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="wide" />
        <feColorMatrix
          in="wide"
          type="matrix"
          values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.55 0"
          result="wideDim"
        />
        <feMerge>
          <feMergeNode in="wideDim" />
          <feMergeNode in="tight" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
  );
}
